import React, { useState, useEffect, useRef } from "react";
import "./TextSwitch.scss";
import { Stack, Button } from "_core/components/common/UI";

export const TextSwitch = (props) => {
    const [currentState, setCurrentState] = useState(props.value);
    const [currentIndex, setCurrentIndex] = useState(0);
    const buttonRowRef = useRef(null);

    useEffect(() => {
        if (!props.options)
        {
            return
        }
        setCurrentIndex(getIndex(currentState));
    }, [currentState]);

    useEffect(() => {
        if (buttonRowRef.current) {
            const child = buttonRowRef.current.children[currentIndex];
            buttonRowRef.current.style.setProperty(
                "--item-width",
                `${child.offsetWidth}px`
            );
        }
    }, [currentIndex]);

    useEffect(() => {
        setCurrentState(props.value)
    }, [props.value]);

    const getIndex = (value) => {
        if (!props.options) {
            return 0;
        }
        const index = props.options.findIndex(option => option.value === value);
        return index >= 0 ? index : 0;
    }

    const onChangeState = (newState) => {
        if (props.disabled) {
            // 非活性時は切り替えない
            return;
        }

        if (newState === currentState) {
            // 新しい状態が現在の状態と同じ場合は何もしない
            return;
        }

        setCurrentState(newState);
        if (props.onChange) {
            props.onChange(newState);
        }
    }

    return (
        <div className={"row-stack text-switch spacing-4px value-" + props.value + (props.disabled ? " disabled" : "") + " " + props.className} style={{"--cursor-index" : String(currentIndex)}} ref={buttonRowRef}>
            {
                props.options &&
                props.options.map((option) => {
                    const isChecked = (option.value === currentState);
                    return (
                        <Button key={option.value} className="hidden" onClick={() => {onChangeState(option.value)}} disabled={props.disabled}>
                            <Stack className={`label flex-center align-center width-full label-right ${isChecked ? "" : "inactive"}`}>
                                <span>{option.label}</span>
                            </Stack>
                        </Button>
                    )
                })
            }
            <div className="cursor"></div>
        </div>
    );
};

export default TextSwitch;
